import { Box, Button, FormControlLabel, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField, Switch } from 'formik-mui'
import React from 'react'
import { TypePosition } from '../../../components/TypePosition/types/TypePosition'

interface TypePositionEditFormProps {
  typePosition: TypePosition
  onSubmit: (values: TypePosition) => void
  isSubmitting?: boolean
}

export const NewTypePositionEditForm: React.FC<TypePositionEditFormProps> = ({
  typePosition,
  onSubmit,
  isSubmitting: externalSubmitting
}) => {
  return (
    <Formik
      initialValues={typePosition}
      onSubmit={async (values: TypePosition) => {
        onSubmit(values)
      }}
    >
      {({
        isSubmitting,
        values: { considerInventory, requireZone },
        handleChange
      }) => (
        <Box component={Form}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
              <Field
                fullWidth
                name='typePositionId'
                component={TextField}
                label='ID'
                variant='outlined'
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                fullWidth
                name='typePositionCode'
                component={TextField}
                label='Código Tipo Posición'
                variant='outlined'
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                fullWidth
                name='typePositionDescription'
                component={TextField}
                label='Descripción Tipo Posición'
                variant='outlined'
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <Box padding='10px' justifyContent='center' alignItems='center'>
                <FormControlLabel
                  control={
                    <Field
                      name='considerInventory'
                      component={Switch}
                      type='checkbox'
                      onChange={handleChange}
                      checked={considerInventory}
                    />
                  }
                  label={
                    considerInventory
                      ? 'Se considera para informar inventario'
                      : 'No se considera para informar inventario'
                  }
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box padding='10px' justifyContent='center' alignItems='center'>
                <FormControlLabel
                  control={
                    <Field
                      name='requireZone'
                      component={Switch}
                      type='checkbox'
                      onChange={handleChange}
                      checked={requireZone}
                    />
                  }
                  label={requireZone ? 'Requiere Zona' : 'No Requiere Zona'}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box display='flex' justifyContent='flex-end'>
                <Button
                  fullWidth
                  variant='contained'
                  color='primary'
                  type='submit'
                  disabled={isSubmitting || externalSubmitting}
                >
                  Guardar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </Formik>
  )
}
